module.exports = __webpack_public_path__ + "img/s-1.b9626b08.png";